import { render, staticRenderFns } from "./TheGetTheAppButton.vue?vue&type=template&id=f12b79d6&scoped=true&"
import script from "./TheGetTheAppButton.js?vue&type=script&lang=js&"
export * from "./TheGetTheAppButton.js?vue&type=script&lang=js&"
import style0 from "./TheGetTheAppButton.scss?vue&type=style&index=0&id=f12b79d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12b79d6",
  null
  
)

export default component.exports